import React, { useState } from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import _ from 'lodash';

export function MultiselectField({ fieldConfig, selectValue, changeSelectValue }) {
  const [value, setValue] = useState(selectValue || []);

  return (
    <FormControl variant="standard" fullWidth={fieldConfig.fullWidth} style={{ pointerEvents: 'none' }}>
      <InputLabel id={fieldConfig.fieldName} required={fieldConfig.required}>
        {_.get(fieldConfig, 'displayLabel.en', '')}
      </InputLabel>
      <Select
        multiple
        value={value}
        disabled={fieldConfig.disabled}
        labelId={fieldConfig.fieldName}
        required={fieldConfig.required}
      >
        {fieldConfig.fieldOptions.map((option, index) => {
          return (
            <MenuItem key={index} value={option.optionValue}>
              {_.get(option, 'displayLabel.en', '')}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{_.get(fieldConfig, 'helperText.en', '')}</FormHelperText>
    </FormControl>
  );
}
